import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoginModalOpen: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    openLoginModal: (state) => {
      if (!state.isLoginModalOpen) {
        state.isLoginModalOpen = true;
      }
    },
    closeLoginModal: (state) => {
      state.isLoginModalOpen = false;
    },
  },
});

export const { openLoginModal, closeLoginModal } = authSlice.actions;
export default authSlice.reducer;
